module.exports = __webpack_public_path__ + "media/brands/microcar-0a8709a4.png";